import { render, staticRenderFns } from "./PaymentSuccessful2.vue?vue&type=template&id=6a0904ee&scoped=true"
import script from "./PaymentSuccessful2.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessful2.vue?vue&type=script&lang=js"
import style0 from "./PaymentSuccessful2.vue?vue&type=style&index=0&id=6a0904ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0904ee",
  null
  
)

export default component.exports